import { withStyles } from "@mui/styles";
import { getGroupStatusByStatus } from "components/statistics/container";
import { getReviewUserStatusKey } from "components/statistics/logic/actions";
import { statisticsStyles } from "components/statistics/styles";
import { ACTION_STATES } from "core/actions";
import { assertArray } from "core/validation";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Bar, BarChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

class ReviewUserChart extends PureComponent {
    renderBar = () => {
        const { statuses, globalStatuses } = this.props;
        const result = [];

        if (assertArray(statuses)) {
            statuses
                .filter((s) => s.value !== 1)
                .map((status) => {
                    result.push(
                        <Bar
                            key={status.id}
                            dataKey={getReviewUserStatusKey(status.value)}
                            name={status.label}
                            {...getGroupStatusByStatus(status)}
                        />
                    );
                });
        } else if (assertArray(globalStatuses)) {
            globalStatuses
                .filter((s) => s.id !== 1)
                .map((status) => {
                    result.push(
                        <Bar
                            key={status.id}
                            dataKey={getReviewUserStatusKey(status.id)}
                            name={status.name}
                            {...getGroupStatusByStatus(status)}
                        />
                    );
                });
        }

        return result;
    };
    render() {
        const { classes, data, reviewUserQueryStatus } = this.props;
        const isLoading = reviewUserQueryStatus !== ACTION_STATES.SUCCESS;
        const failed = reviewUserQueryStatus === ACTION_STATES.FAILED;
        const chart = (
            <ResponsiveContainer>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="1 1" />
                    <XAxis interval={0} dataKey="name" />
                    <YAxis allowDecimals={false}/>
                    <Tooltip isAnimationActive={false} />
                    {data.length > 11 && <Brush travellerWidth={0} tickFormatter={() => null} traveller={(props) => <div {...props} className="hidden"/>} dataKey={null} startIndex={0} endIndex={10} height={20}/>}
                    <Legend />
                    {this.renderBar()}
                </BarChart>
            </ResponsiveContainer>
        );
        return (
            <div className={classes.responsiveChart}>
                {!isLoading && chart}
                {isLoading && !failed && <div>Loading....</div>}
                {!isLoading && failed && <div>Failed</div>}
            </div>
        );
    }
}

ReviewUserChart.propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    reviewUserQueryStatus: PropTypes.string.isRequired,
    statuses: PropTypes.array,
    globalStatuses: PropTypes.array,
};

export default withStyles(statisticsStyles)(ReviewUserChart);
